import { render, staticRenderFns } from "./SmsInvalidCharacterAlert.vue?vue&type=template&id=55d7975e&scoped=true"
var script = {}
import style0 from "./SmsInvalidCharacterAlert.vue?vue&type=style&index=0&id=55d7975e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7975e",
  null
  
)

export default component.exports